<template lang="pug" src="./photo-reports-list.pug"> </template>
<style lang="scss" src="./photo-reports-list.scss" scoped> </style>

<script>
import { mapState } from 'vuex';

import removeDialog from './remove-dialog';
import editDialog from './edit-dialog';

export default {
    components: {
        'v-remove-dialog': removeDialog,
        'v-edit-dialog': editDialog
    },
    data: () => ({
        editDialog: false,
        editedPhotoReport: null,
        removeDialog: false,
        removePhotoReportid: null,
        filters: {
            endDate: null,
            requestName: null,
            reasonId: null,
            active: null,
            callSign: null,
            brandId: null,
            startDate: null,
            status: 'open'
        },
        startDateModal: false,
        endDateModal: false
    }),
    computed: {
        ...mapState({
            brands: (state) => state.data.brands,
            reasons: (state) => state.photoReasons.reasons,
            activePhotoReports: (state) => state.photoReports.activePhotoReports,
            finishedPhotoReports: (state) => state.photoReports.finishedPhotoReports,
            paginationActive: (state) => state.photoReports.paginationActive,
            paginationFinished: (state) => state.photoReports.paginationFinished
        }),
        isActive() {
            return this.filters.status === 'open';
        },
        headers() {
            return [
                '#', 'requestName', 'reasonName', 'allDrivers',
                'acceptedDrivers', 'rejectedDrivers', 'newDrivers',
                'actions', 'createdAt', 'active'
            ].map((it) => ({
                text: this.$vuetify.lang.t(`$vuetify.pages.PhotoReport.photoReportsList.table.${it}`),
                value: it,
                sortable: false,
                align: 'center'
            }));
        },
        finishedHeaders() {
            return ['#', 'requestName', 'reasonName', 'allDrivers', 'acceptedDrivers', 'rejectedDrivers', 'actions', 'createdAt'].map((it) => ({
                text: this.$vuetify.lang.t(`$vuetify.pages.PhotoReport.photoReportsList.table.${it}`),
                value: it,
                sortable: false,
                align: 'center'
            }));
        },
        animationName() {
            return this.isActive ? 'slide-right' : 'slide-left';
        },
        colsLgCount() {
            return this.isActive ? 5 : 6;
        }
    },
    created: function() {
        this.$store.dispatch('photoReasons/getAllReasons');
        this.$store.dispatch('data/getBrands');
        this.loadActiveRequests();
    },
    beforeRouteLeave(to, from, next) {
        this.$store.commit('photoReasons/SET_REASONS', []);
        this.$store.commit('photoReasons/SET_PAGINATION', {
            page: 1,
            totalPages: 1
        });
        next();
    },
    methods: {
        changeEndDate() {
            this.endDateModal = false;
        },

        changeStartDate() {
            this.startDateModal = false;
        },

        openRemoveDialog(id) {
            this.removePhotoReportid = id;
            this.removeDialog = true;
        },

        changeStatus() {
            this.resetData();

            if (this.isActive) {
                this.filters.status = 'close';
                this.loadFinishedRequests(this.paginationFinished.page);
            }  else {
                this.filters.status = 'open';
                this.loadActiveRequests(this.paginationActive.page);
            }
        },

        resetData() {
            this.filters = {
                endDate: null,
                requestName: null,
                reasonId: null,
                active: null,
                brandId: null,
                callSign: null,
                startDate: null,
                status: this.filters.status
            };
        },

        applyFilters() {
            if (this.isActive) {
                this.loadActiveRequests();
                return;
            }
            this.loadFinishedRequests();
        },

        resetFilters() {
            this.resetData();
            this.applyFilters();
        },

        loadActiveRequests(page = 1) {
            this.$store.dispatch('photoReports/getActivePhotoReports', {
                ...this.filters,
                page
            });
        },

        loadFinishedRequests(page = 1) {
            this.$store.dispatch('photoReports/getFinishedPhotoReports', {
                ...this.filters,
                page
            });
        },

        openEditDialog(request) {
            this.editedPhotoReport = Object.select(request, [
                'id', 'requestName', 'reasonId',
                'reasonName', 'allDrivers'
            ]);

            this.editDialog = true;
        },

        onEditDialogClose() {
            this.editedPhotoReport = null;
        },

        onActivityChange(requestId) {
            this.$store.dispatch('photoReports/changeActivity', requestId);
        },

        navigate(id) {
            this.$router.push(`/photo-report/${id}`);
        }
    }
};
</script>
